import api from "./api";

// Capa de servicios API del dominio "etiquetas" (tags) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).
// Nota: los grupos de etiquetas viven en tagGroups.api.js.

// --- Listados ---
export const listTags = (params) => api.get("/tags", { params });
export const listTagsSimple = (params) => api.get("/tags/list", { params });
export const listKanbanTags = () => api.get("/tags/kanban");

// --- CRUD ---
export const getTag = (tagId) => api.get(`/tags/${tagId}`);
export const createTag = (payload) => api.post("/tags", payload);
export const updateTag = (tagId, payload) => api.put(`/tags/${tagId}`, payload);
export const deleteTag = (tagId) => api.delete(`/tags/${tagId}`);

// --- Sincronización (Kanban) ---
export const syncTags = (payload) => api.post("/tags/sync", payload);
